/* globals theShowOnMap, ajaxNavigateTo, zeitraumFilterVon, zeitraumFilterBis, luxon, getUrlPart */
/* exported initVeranstaltungsFilter, initVeranstaltungsListe */

/** @typedef {import('@easepick/bundle')} easepick */
/** @typedef {import('luxon').DateTime} DateTime */

/**
 * @param {luxon.DateTime} filterVon -
 * @param {luxon.DateTime} filterBis -
 * @returns {void}
 */
function createDateBadges(filterVon, filterBis) {
	'use strict';
	$('.veranstaltung-list-date-icon, .veranstaltung-detail-date-icon').each(function () {
		if (this.innerHTML === '') {
			const von = luxon.DateTime.fromSeconds($(this).data('von'));
			/** @type {luxon.DateTime|null} */
			let datum = null;

			if (filterVon && filterBis && filterVon.isValid && filterBis.isValid) {
				if (filterVon.hasSame(filterBis, 'day')) {
					datum = filterVon;
				} else if (+filterVon.startOf('day') <= +von.startOf('day') && +von.startOf('day') <= +filterBis.startOf('day')) {
					datum = von;
				} else {
					datum = filterVon;
				}
			} else {
				datum = von;
			}

			if (datum) {
				$(this).html(
					`<div class="veranstaltung-list-date-icon-month">${datum.toLocaleString({ month: 'short' })}</div>` +
						`<div class="veranstaltung-list-date-icon-day">${datum.toLocaleString({ day: '2-digit' })}</div>`
				);
			}
		}
	});
}

function veranstaltungenAjaxNavigate(url) {
	'use strict';
	$('.col-veranstaltung-map').LoadingOverlay('show');
	disableFilter(true);
	theShowOnMap.clear();
	ajaxNavigateTo(url, 'veranstaltungs-liste').then(success => {
		if (success) {
			createDateBadges(zeitraumFilterVon, zeitraumFilterBis);
			theShowOnMap.init();
		}
		$('.col-veranstaltung-map').LoadingOverlay('hide', true);
		disableFilter(false);
	});
}

// eslint-disable-next-line valid-jsdoc
/**
 *
 * @param {{ zeitraum?: string, kategorie?: string, plz?: string, km?: number }} data URL-Daten
 * @returns {string} URL
 */
function buildVeranstaltungenAjaxNavigateUrl(data) {
	'use strict';
	const festeUrlParts = ['zeitraum', 'kategorie', 'umkreis', 'seite'];
	const urlSplit = window.location.href.split('/');
	const baseUrl = urlSplit.slice(0, Math.min(...festeUrlParts.map(u => urlSplit.indexOf(u)).filter(i => i > 0))).join('/');

	const urlParts = [baseUrl];
	const zeitraum = 'zeitraum' in data ? data.zeitraum : getUrlPart('zeitraum', 2);
	if (zeitraum) {
		urlParts.push('zeitraum', zeitraum);
	}

	const kategorie = 'kategorie' in data ? data.kategorie : getUrlPart('kategorie');
	if (kategorie) {
		urlParts.push('kategorie', kategorie);
	}

	if ('plz' in data && 'km' in data) {
		if (data.plz && data.km) {
			// wenn definiert aber nicht "gefüllt", dann entfernen
			urlParts.push('umkreis', data.plz, data.km);
		}
	} else {
		const umkreisAusUrl = getUrlPart('umkreis', 2);
		if (umkreisAusUrl) {
			urlParts.push('umkreis', umkreisAusUrl);
		}
	}

	return urlParts.join('/');
}

// eslint-disable-next-line strict
function disableFilter(disabled = true) {
	$('select', '.col-veranstaltung-datepicker').prop('disabled', disabled);
	if (disabled) {
		$('<div class="date-picker-disable" />').prependTo('#datepicker-veranstaltungen');
	} else {
		$('.date-picker-disable', '#datepicker-veranstaltungen').remove();
	}
}

async function initVeranstaltungsFilter(availableDates) {
	'use strict';

	const DateTime = luxon.DateTime;

	/**
	 * @param {string} selectWert selektierter Wert dert <select>
	 * @returns {{ start: Date, ende: Date }} Start- und Ende-Datum
	 */
	function datumsSelektionZuDatum(selectWert) {
		/** @type {DateTime} */
		const heute = DateTime.local().startOf('day');
		switch (selectWert) {
			case 'heute':
				return { start: heute.toJSDate(), ende: heute.toJSDate() };
			case 'dieses-wochenende':
				return { start: heute.set({ weekday: 5 }).toJSDate(), ende: heute.set({ weekday: 7 }).toJSDate() };
			case 'naechstes-wochenende':
				return { start: heute.set({ weekday: 5 }).plus({ weeks: 1 }).toJSDate(), ende: heute.set({ weekday: 7 }).plus({ weeks: 1 }).toJSDate() };
			case 'naechste-woche':
				return { start: heute.plus({ weeks: 1 }).startOf('week').toJSDate(), ende: heute.plus({ weeks: 1 }).endOf('week').toJSDate() };
			case 'naechste-30-tage':
				return { start: heute.toJSDate(), ende: heute.plus({ days: 30 }).toJSDate() };
			case 'naechste-60-tage':
				return { start: heute.toJSDate(), ende: heute.plus({ days: 60 }).toJSDate() };
		}
		return null;
	}

	/** @type {easepick} */
	const easepick = window.easepick;
	const datePicker = new easepick.create({
		element: '#veranstaltungs-zeitraum',
		css: ['/fileadmin/vendor/easepick/dist/index.css', '/fileadmin/templates/css/easepick-override-veranstaltung.css'],
		lang: 'de-DE',
		inline: true,
		RangePlugin: {
			delimiter: '/',
			locale: {
				one: 'Tag',
				other: 'Tage',
			},
		},
		LockPlugin: {
			minDate: availableDates[0],
			maxDate: availableDates.slice(-1)[0],
		},
		KbdPlugin: {
			unitIndex: 0,
			dayIndex: 0,
		},
		plugins: ['RangePlugin', 'LockPlugin', 'KbdPlugin'],
		locale: {
			previousMonth:
				'<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><title>vorheriger Monat</title><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>',
			nextMonth:
				'<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><title>nächster Monat</title><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>',
		},
	});
	datePicker.gotoDate(datePicker.getStartDate());
	datePicker.on('select', () => {
		veranstaltungenAjaxNavigate(buildVeranstaltungenAjaxNavigateUrl({ zeitraum: document.getElementById('veranstaltungs-zeitraum').value }));
	});
	$('#date-select-veranstaltungen').select2({
		width: '100%',
		minimumResultsForSearch: -1,
		placeholder: Array.from(document.getElementById('date-select-veranstaltungen').childNodes).find(elem => elem.value === '').innerText,
	});
	$('#date-select-veranstaltungen').on('change', function () {
		const neuerZeitraum = datumsSelektionZuDatum($(this).val());
		if (!neuerZeitraum) {
			return;
		}
		datePicker.gotoDate(neuerZeitraum.start);
		datePicker.setDateRange(neuerZeitraum.start, neuerZeitraum.ende);
		$(this).val('').trigger('change');
		veranstaltungenAjaxNavigate(buildVeranstaltungenAjaxNavigateUrl({ zeitraum: document.getElementById('veranstaltungs-zeitraum').value }));
	});

	$('#kategorie-filter').select2({ width: '100%' });
	const kategorie = getUrlPart('kategorie');
	if (kategorie) {
		$('#kategorie-filter').val(kategorie).trigger('change');
	}
	$('#kategorie-filter').on('change', function () {
		veranstaltungenAjaxNavigate(buildVeranstaltungenAjaxNavigateUrl({ kategorie: $(this).val() }));
	});

	$('#umkreis-km').select2({ minimumResultsForSearch: -1 });
	$('#umkreis-plz')
		.select2({
			allowClear: true,
			placeholder: 'PLZ / Ort',
			ajax: {
				url: '/ajax-json/plz-liste',
				dataType: 'json',
			},
		})
		.on('select2:unselecting', function () {
			$(this).data('unselecting', true);
		})
		.on('select2:opening', function (e) {
			if ($(this).data('unselecting')) {
				$(this).removeData('unselecting');
				e.preventDefault();
			}
		});
	const [plz, km] = getUrlPart('umkreis', 2, true) || [];
	if (plz && km) {
		const data = await fetch(`/ajax-json/plz-liste?term=${plz}`)
			.then(res => res.json())
			.then(data => data.results[0]);
		const option = new Option(data.text, data.id, true, true);
		$('#umkreis-plz').append(option).trigger('change');
		$('#umkreis-km').val(km).trigger('change');
	}
	const plzUndOrtUebernehmen = (force = false) => {
		const plz = $('#umkreis-plz').val();
		const km = $('#umkreis-km').val();
		if (plz && km) {
			veranstaltungenAjaxNavigate(buildVeranstaltungenAjaxNavigateUrl({ plz, km }));
		} else if (force) {
			veranstaltungenAjaxNavigate(buildVeranstaltungenAjaxNavigateUrl({ plz: null, km: null }));
		}
	};
	$('#umkreis-plz').on('change', () => {
		plzUndOrtUebernehmen(true);
	});
	$('#umkreis-km').on('change', () => {
		plzUndOrtUebernehmen();
	});
}

function initVeranstaltungsListe() {
	'use strict';
	createDateBadges(zeitraumFilterVon, zeitraumFilterBis);
	$('.veranstaltungen')
		.attr('aria-disabled', true)
		.on('click', '.pagination a', function (evt) {
			evt.preventDefault();
			veranstaltungenAjaxNavigate(this.href);
			return false;
		});
}

$(() => {
	'use strict';
	if (document.activeElement) {
		document.activeElement.blur();
	}
});
